import React from 'react';
import FormattedInput from '../FormattedInput/FormattedInput';
import { NumberFormatValues } from 'react-number-format';
import { DEFAULT_TIP_PLACEHOLDERS } from './constants';
import styles from './TipValueInputs.module.scss';

export interface TipValueInputsProps {
  /** Array of tip percentage values */
  values: number[];
  /** Callback when a value changes - receives index and new value */
  onChange: (index: number, value: number) => void;
  /** Optional placeholder values for each input */
  placeholders?: string[];
  /** Loading state */
  loading?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Key prefix for React keys */
  keyPrefix?: string;
}



const TipValueInputs: React.FC<TipValueInputsProps> = ({
  values,
  onChange,
  placeholders = DEFAULT_TIP_PLACEHOLDERS,
  loading = false,
  className = '',
  keyPrefix = 'tip-value',
}) => {
  const handleValueChange = (index: number, values: NumberFormatValues) => {
    const numValue = typeof values.floatValue === 'number' ? values.floatValue : 0;
    onChange(index, numValue);
  };

  return (
    <div className={`${styles.tipValueInputs} ${className}`}>
      {values.map((value, index) => (
        <div key={`${keyPrefix}-${index}`} className={styles.controlWidth}>
          <FormattedInput
            format="percentage"
            decimalScale={0}
            value={value}
            onValueChange={(v) => handleValueChange(index, v)}
            placeholder={placeholders[index] || DEFAULT_TIP_PLACEHOLDERS[index % DEFAULT_TIP_PLACEHOLDERS.length]}
            loading={loading}
          />
        </div>
      ))}
    </div>
  );
};

export default TipValueInputs;
